let baseURL = "";
 if(process.env.NODE_ENV == "development"){//dev
  baseURL = "http://127.0.0.1:8080";
  //baseURL = "http://192.168.2.160:8080";//晓龙

  //baseURL = "http://jxc.coopwin.vip";
}else if(process.env.NODE_ENV == "production"){//build
  baseURL = window.location.origin;
  //baseURL = "http://jxc.coopwin.vip";
}
export default baseURL; 
